import { DataLayer } from "@allwyn/utils/data-layer";

export namespace HelpCenterAnalytics {
    export const openAnalyticsChat = () => {
        DataLayer.push({
            event: "action.openChat.helpcenter",
        });
    };

    export const selectAnalyticsTopic = (topicName: string) => {
        DataLayer.push({
            event: "action.selectTopic.helpcenter",
            action: {
                selectTopic: {
                    label: topicName,
                },
            },
        });
    };

    export const selectAnalyticsCategory = (topicName: string, categoryName: string) => {
        DataLayer.push({
            event: "action.selectCategory.helpcenter",
            action: {
                selectCategory: {
                    label: topicName,
                    eventProperty1: categoryName,
                },
            },
        });
    };

    export const selectAnalyticsQuestion = (topicName: string, categoryName: string, question: string) => {
        DataLayer.push({
            event: "action.selectQuestion.helpcenter",
            action: {
                selectQuestion: {
                    label: topicName,
                    eventProperty1: categoryName,
                    eventProperty2: question,
                },
            },
        });
    };
}
